import { composeIO } from 'react-compose-io'
import { recuperacaoBoxIO } from './RecuperacaoBox.IO'
import { RecuperacaoBoxView } from './RecuperacaoBox.View'

export const RecuperacaoBox = composeIO(RecuperacaoBoxView, recuperacaoBoxIO)
